import { useActionState } from "react";

import { useNavigate } from "react-router-dom";
function isInvalidText(text) {
  return !text || text.trim() === "";
}
//const api_url = "http://localhost:9000/api/admin";
const api_url = "https://api.softplix.com/api/admin/adminLogin";

export default function AuthPage() {
  const [message, formAction, pending] = useActionState(adminLogin, null);

  console.log("message", message);
  const navigate = useNavigate();

  async function adminLogin(prevState, formData) {
    try {
      console.log("formdata", formData);
      const email = formData.get("email");
      const password = formData.get("password");

      if (isInvalidText(email) || isInvalidText(password)) {
        return "Invalid login credentials!";
      }
      const data = {
        id: email,
        password: password,
      };

      const response = await fetch(
        `${api_url}`,

        {
          method: "POST",
          body: JSON.stringify(data),
          // body: JSON.stringify(data),
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!response.ok) {
        return "Invalid login credentials!";
      }
      const responseData = await response.json();

      localStorage.setItem("token", responseData.data[0].token);
      return navigate("/");

      // return response.json();
    } catch (error) {
      console.log("error", error);
      return "Invalid login credentials!";
    }
  }

  return (
    <div className="w-screen h-screen flex justify-center items-center relative">
      <div className="border p-5">
        <h1 className="text-3xl font-bold">Welcome Back!</h1>
        <form className="w-full" action={formAction}>
          <label className="block text-slate-400 mt-5 text-sm" htmlFor="email">
            Email Address
          </label>
          <input
            type="text"
            id="email"
            name="email"
            className="border border-slate-400 rounded-md px-3 py-2 w-[400px]"
            required
          />
          <label
            className="block text-slate-400 mt-5 text-sm"
            htmlFor="password"
          >
            Password
          </label>
          <input
            type="password"
            id="password"
            name="password"
            className="border border-slate-400 rounded-md px-3 py-2 w-[400px] block"
            required
          />
          {typeof message === "string" && (
            <p className="mt-5 text-sm text-red-500">{message}</p>
          )}
          <button
            type="submit"
            disabled={pending}
            className="rounded-md w-[400px] text-white bg-customBlue py-3 mt-10"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
}
